// base in 2.4.1
import Dropdown from './Dropdown';
export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-dropdown/src/index.js
// module id = 804
// module chunks = 0